export default {"src":"/_next/static/media/xcp.d69c6a00.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};